import { laboratoryClient } from '../utils/laboratoryClient';
import { useEffect, useState } from 'react';
import { TX111_TREATMENT_KEY, TX111_GROUP_PARAMETER_OPTIONS } from '../constants/experimentKeys'; // TX-111: Offering extended trials

export const useIsTx111VariantC = () => {
  const [isTx111VariantC, setIsTx111VariantC] = useState();
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      if (Object.keys(treatments).length) {
        const extension = treatments[TX111_TREATMENT_KEY].parameters.extension;
        setIsTx111VariantC(extension === TX111_GROUP_PARAMETER_OPTIONS.variant_C);
      }
    });
  }, [isTx111VariantC]);
  return isTx111VariantC;
};